import { useNotifications } from "@/contexts/NotificationContext";
import { AvisoDaUrlComMarcador } from "./AvisoDaUrlComMarcador";

/** O consumidor do `?aviso=<id>` do app INTERNO (passo 8): marca pelo `NotificationContext`. O do portal é o `AvisoDaUrlDoPortal`. */
export function AvisoDaUrl(): JSX.Element {
  const { markAsRead } = useNotifications();
  return <AvisoDaUrlComMarcador marcarLida={markAsRead} />;
}
